import { Directive, Input, Output, EventEmitter, HostListener, OnInit, inject } from '@angular/core';
import { MatDialogRef, MatDialog } from '@angular/material/dialog';
import { tap } from 'rxjs';
import { ConfirmComponent } from './confirm.component';
import { ConfirmService } from './confirm.service';
import { ConfirmOutput } from './confirm-output.interface';
import { ConfirmConfig } from './confirm-config.interface';

@Directive({ selector: '[caConfirm]' })
export class ConfirmDirective implements OnInit {
    private matDialog = inject(MatDialog);
    private confirmService = inject(ConfirmService);

    private confirmRef: MatDialogRef<ConfirmComponent, ConfirmOutput>;

    @Input('caConfirm') config: ConfirmConfig = {};

    @Input() caConfirmContext: any;

    @Output() confirm: EventEmitter<void> = new EventEmitter<void>();

    // eslint-disable-next-line @angular-eslint/no-output-native
    @Output() cancel: EventEmitter<void> = new EventEmitter<void>();

    @Output() closed: EventEmitter<void> = new EventEmitter<void>();

    public ngOnInit(): void {
        if (this.config.uuid) {
            this.confirmService.register(this.config.uuid);
        }
    }

    @HostListener('click', ['$event'])
    public openDialog(e: MouseEvent): void {
        if (this.config.disabled) {
            return;
        }
        e.stopPropagation();
        e.stopImmediatePropagation();
        e.preventDefault();

        this.confirmRef = this.matDialog.open(ConfirmComponent, {
            width: '520px',
            panelClass: 'ca-dialog',
            disableClose: true,
            autoFocus: false,
            data: { ...this.config, context: this.caConfirmContext }
        });
        this.handleDialogClose();
    }

    private handleDialogClose(): void {
        this.confirmRef
            .afterClosed()
            .pipe(
                tap(output => {
                    if (output?.confirm) {
                        this.confirm.emit();
                    } else if (output?.cancel) {
                        this.cancel.emit();
                    } else if (output?.close) {
                        this.closed.emit();
                    }

                    if (this.config.uuid) {
                        this.confirmService.confirm(this.config.uuid, output);
                    }
                })
            )
            .subscribe();
    }
}
